import { Gender, IAssignedInstitution, IDoctor } from '@alberta/konexi-shared';
import { IDoctorDraft } from '@alberta/konexi-shared/dist/institution/doctor-draft';
import { ISearchable } from 'src/app/common/contracts/components/searchable';

import { AggregateRoot } from '../aggregate-root';

export class DoctorDto extends AggregateRoot implements IDoctor, ISearchable {
  gender: Gender;
  titleShort: string;
  title: string;
  firstName: string;
  lastName: string;
  address: string;
  postalCode: string;
  city: string;
  phone: string;
  fax: string;
  institution: IAssignedInstitution;
  ldn: string;
  en: string;
  emailPrescriptionRequest: string;
  faxPrescriptionRequest: string;
  email: string;
  website: string;
  correspondenceType: string;
  lifelongNumber: string;
  siteNumber: string;
  draft: IDoctorDraft;

  constructor() {
    super();
  }

  get displayText(): string {
    return `${this.titleShort ? this.titleShort + ' ' : ''}${
      this.firstName && this.firstName.length ? this.firstName + ' ' : ''
    }${this.lastName} ${this.city}`;
  }
}
